import { forwardRef } from 'react';
import IconBase from '../IconBase';
import { Icon } from '../types';

const Heart: Icon = forwardRef((props, ref) => (
  <IconBase viewBoxBase={780} ref={ref} {...props}>
    <path d='M390 600.85c-2.62 0-5.25-.69-7.59-2.06-2.23-1.31-55.17-32.57-108.89-82.64-31.83-29.67-57.26-59.8-75.59-89.55-23.51-38.17-35.43-75.94-35.43-112.26 0-74.54 56.23-135.18 125.34-135.18 43.36 0 80.03 32.21 102.16 69.19 22.13-36.98 58.81-69.19 102.16-69.19 69.11 0 125.34 60.64 125.34 135.18 0 36.32-11.92 74.09-35.43 112.26-18.33 29.76-43.76 59.89-75.59 89.55-53.72 50.07-106.66 81.34-108.89 82.64a15.035 15.035 0 0 1-7.59 2.06zM287.84 209.16c-52.57 0-95.34 47.18-95.34 105.18 0 121.5 160.37 230.32 197.5 253.88 37.11-23.58 197.5-132.54 197.5-253.88 0-58-42.77-105.18-95.34-105.18-38.43 0-73.42 39.6-88.12 78.72-2.2 5.85-7.79 9.72-14.04 9.72s-11.84-3.87-14.04-9.72c-14.7-39.12-49.69-78.72-88.12-78.72z' />
  </IconBase>
));

Heart.displayName = 'Heart';

export default Heart;
